module.exports = __webpack_public_path__ + "img/index03.8870b82f.jpg";